<template>
  <div class="inner">
    <ScrollupSection />
    <div class="all-area">
      <HeaderSection />
      <DeleteAccountSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../../Scrollup/Scrollup'
import HeaderSection from '../../Header/HeaderOne'
import DeleteAccountSection from '../../DeleteAccount/DeleteAccount'
import FooterSection from '../../Footer/Footer'

export default {
  name: 'DeleteAccount',
  components: {
    ScrollupSection,
    HeaderSection,
    DeleteAccountSection,
    FooterSection
  }
}
</script>

<style>

</style>